import React, { FC, useState } from 'react'
import { blockDictActions } from '../../../../store/actions/modelsActions/control'
import { useAppDispatch } from '../../../../hooks/useAppDispatch'
import { DictionaryValueEdit } from './DictionaryValueEdit'
import AppButton from '../../../buttons/AppButton/AppButton'
import { showModal } from '../../../../store/actions/modalActions'
import { ModalTypes } from '../../../../types/modals'
import { PATH_JOINER } from '../../utils/getConfigBitPath'
import { deleteRuleBlockDictItem } from '../../../../store/actions/ruleCardActions'
import { deleteBlockDictItem } from '../../../../store/actions/actionsActions'

export interface IBlockDictionaryRow {
    dataPath: string
    data?: any
    dataSchema: any
    name: string
    position: number
    dictionaryKey: string
    value: string
    setDictKeys: React.Dispatch<React.SetStateAction<string[]>>
    actionAddDictValue?: (item: Record<string, string>) => void
    ruleCardAddDictValue?: (item: Record<string, string>) => void
}

const BlockDictionaryRow: FC<IBlockDictionaryRow> = ({
    dataPath,
    data = {},
    dataSchema = {},
    name,
    position,
    dictionaryKey,
    value,
    setDictKeys,
    actionAddDictValue,
    ruleCardAddDictValue,
}) => {
    const dispatch = useAppDispatch()
    const path = [...(dataPath.split(PATH_JOINER)), name]
    const [isEditing, setIsEditing] = useState(false)

    const hideEditForm = () => setIsEditing(false)
    const showEditForm = () => setIsEditing(true)

    const onDeleteDiction = (): void => {
        if (actionAddDictValue) {
            dispatch(deleteBlockDictItem({
                path,
                data,
                dictionaryKey,
            }))
        } else if (ruleCardAddDictValue) {
            dispatch(deleteRuleBlockDictItem({
                path,
                data,
                dictionaryKey,
            }))
        } else (
            dispatch(blockDictActions.deleteItem(path, data, dictionaryKey))
        )
        setDictKeys((prev) => prev.filter((dict) => dict !== dictionaryKey))
    }

    const handleDelete = () =>
        dispatch(
            showModal(ModalTypes.MAIN_MODAL, {
                body: `Delete row ${position}?`,
                onSubmit: onDeleteDiction,
            })
        )

    if (isEditing)
        return (
            <DictionaryValueEdit
                path={path}
                dictionaryKey={dictionaryKey}
                dictionaryValue={value}
                schema={dataSchema}
                hideEditForm={hideEditForm}
                actionAddDictValue={actionAddDictValue}
                ruleCardAddDictValue={ruleCardAddDictValue}
            />
        )

    return (
        <tr style={{ display: 'table-row' }}>
            <td className={`${isEditing ? 'pt-4' : ''}`}>{position}</td>
            <td>{dictionaryKey}</td>
            <td>{String(value)}</td>
            <td className="d-flex justify-content-center">
                <AppButton
                    variant="edit"
                    onClick={showEditForm}
                    tooltip="tooltips.editRow"
                />
                <AppButton
                    variant="delete"
                    onClick={handleDelete}
                    tooltip="tooltips.deleteRow"
                />
            </td>
        </tr>
    )
}

export default BlockDictionaryRow
